import searchUtils from './rbmc.suggestSearch';
import debounce from '../utils/rbmc.debounce';
import urlUtils from '../utils/rbmc.url-utils';

let debounceSearch = undefined;

const searchBox = {
    searchBoxResetClass:    '.js-search-box__reset',
    searchBoxInputClass:    '.js-search-box__input',
    $searchComponentButton: undefined,
    currentSearchBox:       undefined,
    $body:                  undefined,
    $html:                  undefined,
    globalSearchVisible:    false,
    searchComponent:        undefined,
    suggestionsWrapper:     undefined,
    debounceTime:           250,
    curtainElement:         undefined,

    showGlobalSearch() {
        const searchBoxInput        = searchBox.$body.find('.page-header .js-search-box__input');
        const searchVisibilityClass = 'show-search-box--visible';
        searchBox.$html.addClass(searchVisibilityClass);
        //Search may not be ready immediately
        setTimeout(() => {
            searchBoxInput.focus();
            // HACK - fix wrong input cursor position after focus event
            searchBoxInput[0].selectionStart = searchBoxInput[0].selectionEnd = searchBoxInput.val().length;
            searchBox.globalSearchVisible = true;
        }, 300);
    },

    hideGlobalSearch() {
        const searchBoxInput        = searchBox.$body.find('.page-header .js-search-box__input');
        const searchVisibilityClass = 'show-search-box--visible';
        searchBoxInput.val('').trigger('keyup');
        searchBoxInput.parents('.search-component__wrapper').find('.page--greyout').remove()
        searchBox.$html.removeClass(searchVisibilityClass);
        searchBox.globalSearchVisible = false;
    },

    handleFocusEvent(evt) {
        const isMainContentSearch = !!$(evt.target).parents('main')[0];
        const isMobileBreakpoint  = Breakpoints.is('mobile');

        if (isMainContentSearch && isMobileBreakpoint) {
            evt.preventDefault();
            evt.stopPropagation();
            searchBox.showGlobalSearch();
        }

        const $activeSearch = $(evt.currentTarget);
        $activeSearch.addClass("search-activated");
        if (!$activeSearch.parent().find('.page--greyout').length) {
            $activeSearch.parent().append('<div class="page--greyout"></div>');
        }
    },

    closeAllSearchBoxes() {
        searchBox.$searchComponent.removeClass('search-activated');
        searchBox.$searchComponent.parent().find('.page--greyout').remove();
        if (searchBox.globalSearchVisible) {
            searchBox.hideGlobalSearch();
            searchUtils.showNoResults(false);
        }
    },

    resetInputValueButton(evt) {
        const $self = $(evt.currentTarget);
        $self.closest('form').find('.search-component__field').val('').focus();
        $self.addClass('d-none');
        searchUtils.showNoResults(false);
        searchUtils.resetSuggestSearch();
    },

    changeVisibilityOfResetButton($input) {
        if ($input.val() !== '') {
            $input.nextAll(searchBox.searchBoxResetClass).removeClass('d-none');
        } else {
            searchUtils.showNoResults(false);
            $input.nextAll(searchBox.searchBoxResetClass).addClass('d-none');
        }
    },

    inputKeyDownActions(evt) {
        const $this                = $(evt.currentTarget);
        searchBox.currentSearchBox = $this;
        searchBox.debounceTime     = $this.data('options').waitTimeBeforeRequest || 250;
        searchBox.changeVisibilityOfResetButton($this);
        switch (evt.which) {
            case 27:
            case 38:
            case 40:
            case 13:
                break;
            default:
                debounceSearch();
                break;
        }
    },

    onSearchSuggestionClick(event) {
        event.stopPropagation();
        event.preventDefault();
        searchBox.redirectToSearchResults($(this).data('suggestion'));
    },

    getNavigationSelectionElement(selectableResults, activeSuggestionClass) {
        return selectableResults.findIndex(elem => $(elem).hasClass(activeSuggestionClass));
    },

    onKeyboardNavigation(keyboardEvent) {
        const activeSuggestionClass = 'search-component__suggestion--active';
        const $activatedSearch      = $('.search-activated');
        const $suggestionsWrapper   = $activatedSearch.find('.search-component__suggestions');
        const selectableResults     = $activatedSearch.find('.selectable').toArray();

        switch (keyboardEvent.which) {
            case 27:
                if (searchBox.globalSearchVisible) {
                    searchBox.hideGlobalSearch();
                }
                break;
            case 13:
                if($(this).val() !== "") {
                    searchBox.redirectToSearchResults(
                            $suggestionsWrapper.find(`.${activeSuggestionClass}`).data('suggestion') || searchUtils.searchTerm
                    )
                }
                break;
            case 38:
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
                let activeSuggestionUp = searchBox.getNavigationSelectionElement(selectableResults, activeSuggestionClass);
                if (activeSuggestionUp === -1) {
                    $(selectableResults[selectableResults.length - 1]).addClass(activeSuggestionClass);
                } else {
                    $(selectableResults[activeSuggestionUp]).removeClass(activeSuggestionClass);
                    activeSuggestionUp === 0 ?
                            $(selectableResults[selectableResults.length - 1]).addClass(activeSuggestionClass) :
                            $(selectableResults[activeSuggestionUp - 1]).addClass(activeSuggestionClass);
                }
                break;
            case 40:
                keyboardEvent.preventDefault();
                keyboardEvent.stopPropagation();
                let activeSuggestionDown = searchBox.getNavigationSelectionElement(selectableResults, activeSuggestionClass);
                if (activeSuggestionDown === -1) {
                    $(selectableResults[0]).addClass(activeSuggestionClass);
                } else {
                    $(selectableResults[activeSuggestionDown]).removeClass(activeSuggestionClass);
                    activeSuggestionDown + 1 === selectableResults.length ?
                            $(selectableResults[0]).addClass(activeSuggestionClass) :
                            $(selectableResults[activeSuggestionDown + 1]).addClass(activeSuggestionClass);
                }
                break;
        }
    },

    searchButtonAction() {
        const $activatedSearch      = $('.search-activated'),
              $activeSuggestionData = $activatedSearch.find('.search-component__suggestion--active').data('suggestion'),
              $searchBoxInput       = $activatedSearch.find(searchBox.searchBoxInputClass).val();
        if ($activeSuggestionData || $searchBoxInput) {
            searchBox.redirectToSearchResults($activeSuggestionData || $searchBoxInput)
        } else {
            $activatedSearch.find(searchBox.searchBoxInputClass).focus();
        }
    },

    redirectToSearchResults(searchTerm) {
        location.href = searchBox.getSearchUrl(searchTerm);
    },

    getSearchUrl(searchTerm) {
        return `${urlUtils.getBaseUrl()}search/?q=${searchTerm}${searchUtils.subShop ? '&subshop=' + searchUtils.subShop : ''}`;
    },

    bindEvents() {
        /**
         * Show global search box.
         */
        this.$body.on('click', '.js-show-search-box', searchBox.showGlobalSearch);
        /**
         * Hide global search box.
         */
        this.$body.on('click', '.js-search-component__close', searchBox.hideGlobalSearch);
        /**
         * Action on input reset button (x). This event will be binded on each search component found on page.
         */
        this.$searchComponent.on('click', searchBox.searchBoxResetClass, searchBox.resetInputValueButton);
        /**
         * Trigger action on search input keyup event.
         */
        this.$searchComponent.on('keyup', searchBox.searchBoxInputClass, searchBox.inputKeyDownActions);
        /**
         * Put a focus on search input and add class "search-activated"
         */
        this.$body.on('focus', '.search-component--suggest', searchBox.handleFocusEvent);
        /**
         * Action when search suggestion is clicked. This will put clicked suggestion in input field and execuste search for that term.
         */
        this.$searchComponent.on('click', '.search-component__suggestion', searchBox.onSearchSuggestionClick);
        /**
         * Executes actions over search suggestions when using keyboard up/down buttons and enter button.
         */
        this.$body.on('keydown', '.search-component--suggest', searchBox.onKeyboardNavigation);
        /**
         * Makes sure that all open search results are hidden when search-component is out of focus.
         */
        this.$body.on('click touch', searchBox.closeAllSearchBoxes);
        /**
         * Prevent click event to bubble out from search component.
         */
        this.$searchComponent.on('click touch', function (e) {
            e.stopPropagation();
        });
        /**
         * We need to prevent submit event of form if user press enter while input is focused.
         */
        this.$searchComponent.on('submit', '.search-component__form', function (e) {
            e.preventDefault()
        });
        /**
         * Search button action
         */
        this.$searchComponentButton.on('click', this.searchButtonAction);
        /**
         * Enable search component after full event bind
         */
        this.$searchComponent.removeClass('search-component--not-ready');
    },

    initSelectors() {
        searchBox.$html                  = $('html');
        searchBox.$body                  = searchBox.$html.find('body');
        searchBox.$searchComponent       = searchBox.$body.find('.search-component--suggest');
        searchBox.suggestionsWrapper     = searchBox.$body.find('.search-component__suggestions');
        searchBox.$searchComponentButton = searchBox.$searchComponent.find('.search-component__button');
    },
};

$(() => {
    if ($('.search-component').length) {
        searchBox.initSelectors();
        searchBox.bindEvents();

        debounceSearch = debounce(function () {
            searchUtils.init(searchBox.currentSearchBox);
        }, searchBox.debounceTime);
    }
});

export default searchBox;
